$( document ).ready(function() {
    var navToggler = $(".navbar-toggler");
    var navID = $("#header-nav");
    var classOpen = "nav-open";
    var activeClass = "active";
    var showClass = "show-nav";



    navToggler.on("click", function () {
        if(navID.hasClass(activeClass)) {
            //close
            setTimeout(function () {
                navID.removeClass(showClass)
            }, 300);

        }else {
            //open
            navID.addClass(showClass)
        }
        navID.toggleClass(activeClass);
        $("body").toggleClass(classOpen);

    })
});